/**
 * SUSHENAH Featured Products - AJAX Add to Cart
 * Handles product card add to cart functionality
 * Opens cart drawer after successful addition
 */

document.addEventListener('DOMContentLoaded', function() {
  initProductCardForms();
});

function initProductCardForms() {
  const forms = document.querySelectorAll('[data-product-card-form]');

  forms.forEach(form => {
    form.addEventListener('submit', handleAddToCart);
  });
}

async function handleAddToCart(e) {
  e.preventDefault();

  const form = e.currentTarget;
  const btn = form.querySelector('[data-add-to-cart-btn]');
  const textEl = btn.querySelector('.product-card__add-text');
  const loadingEl = btn.querySelector('.product-card__loading');

  // Store original text for reset
  const originalText = 'Add to Cart';

  // Get variant ID from form
  const variantId = form.querySelector('input[name="id"]')?.value;
  const quantity = form.querySelector('input[name="quantity"]')?.value || 1;

  // Debug logging
  console.log('Add to Cart Debug:', {
    variantId: variantId,
    quantity: quantity,
    formAction: form.action,
    formHTML: form.innerHTML.substring(0, 200)
  });

  // Validate variant ID
  if (!variantId) {
    console.error('No variant ID found in form');
    if (textEl) {
      textEl.textContent = 'Unavailable';
      setTimeout(() => { textEl.textContent = originalText; }, 2000);
    }
    // Fall back to form submission
    form.submit();
    return;
  }

  // Show loading state
  btn.setAttribute('aria-disabled', 'true');
  btn.classList.add('loading');
  if (textEl) textEl.classList.add('hidden');
  if (loadingEl) loadingEl.classList.remove('hidden');

  // Build simple request body (add to cart first, then fetch drawer)
  const body = {
    id: parseInt(variantId, 10),
    quantity: parseInt(quantity, 10)
  };

  console.log('Sending to /cart/add.js:', body);

  const cartDrawer = document.querySelector('cart-drawer');

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    });

    console.log('Response status:', response.status, response.ok);

    // Hide loading spinner
    if (loadingEl) loadingEl.classList.add('hidden');
    btn.removeAttribute('aria-disabled');
    btn.classList.remove('loading');

    if (!response.ok) {
      // HTTP error (4xx, 5xx)
      const errorData = await response.json().catch(() => ({}));
      console.error('Add to cart error:', response.status, errorData);
      if (textEl) {
        textEl.textContent = errorData.description || 'Unavailable';
        textEl.classList.remove('hidden');
      }
      setTimeout(() => {
        if (textEl) textEl.textContent = originalText;
      }, 2000);
      return;
    }

    const data = await response.json();
    console.log('Add to cart success:', data);

    // Success!
    if (textEl) {
      textEl.textContent = 'Added!';
      textEl.classList.remove('hidden');
    }

    // Update cart bubble
    updateCartBubble();

    // Fetch fresh cart drawer content and open drawer
    if (cartDrawer) {
      await refreshAndOpenCartDrawer(cartDrawer);
    }

    setTimeout(() => {
      if (textEl) textEl.textContent = originalText;
    }, 1500);

  } catch (error) {
    // Network or parsing error - fall back to standard form submission
    console.error('Add to cart AJAX failed, falling back to form submit:', error);

    // Reset button state
    if (loadingEl) loadingEl.classList.add('hidden');
    btn.removeAttribute('aria-disabled');
    btn.classList.remove('loading');
    if (textEl) textEl.classList.remove('hidden');

    // Fall back to standard form submission
    form.submit();
  }
}

// Fetch fresh cart drawer HTML and open it
async function refreshAndOpenCartDrawer(cartDrawer) {
  try {
    // Fetch the cart drawer section with fresh cart data
    const response = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    if (!response.ok) throw new Error('Failed to fetch cart drawer');

    const sections = await response.json();
    console.log('Cart drawer sections fetched:', Object.keys(sections));

    // Update the cart drawer HTML
    if (sections['cart-drawer']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      const newDrawerContent = doc.querySelector('#CartDrawer');
      const currentDrawer = document.querySelector('#CartDrawer');

      if (newDrawerContent && currentDrawer) {
        currentDrawer.innerHTML = newDrawerContent.innerHTML;
        console.log('Cart drawer content updated');

        // Re-attach overlay click handler
        const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay) {
          overlay.addEventListener('click', () => cartDrawer.close());
        }
      }
    }

    // Update cart icon bubble
    if (sections['cart-icon-bubble']) {
      const bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubbleEl) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = doc.querySelector('.shopify-section');
        if (newBubble) {
          bubbleEl.innerHTML = newBubble.innerHTML;
        }
      }
    }

    // Remove is-empty class if it exists
    cartDrawer.classList.remove('is-empty');
    const drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');

    // Open the drawer
    cartDrawer.open();

  } catch (error) {
    console.error('Error refreshing cart drawer:', error);
    // Still try to open the drawer even if refresh failed
    cartDrawer.open();
  }
}

// Update cart icon bubble count
function updateCartBubble() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const bubble = document.querySelector('.cart-count-bubble');
      if (bubble) {
        const countEl = bubble.querySelector('[data-cart-count]') || bubble.querySelector('span');
        if (countEl) countEl.textContent = cart.item_count;
        bubble.classList.remove('hidden');
      }
    })
    .catch(err => console.warn('Could not update cart bubble:', err));
}

// Re-initialize when Shopify section renders (theme editor support)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-product-card-form]')) {
      initProductCardForms();
    }
  });
}
